import React from 'react';
import _ from 'lodash';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import styles from './notificationsListStyles';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import NotificationIndexItemContainer from 'buyside/components/container/Notifications/NotificationIndexItemContainer';

class NotificationsList extends React.Component {
  constructor() {
    super();
    this.onScroll = this.onScroll.bind(this);
    this.state = { loading: false };
  }

  componentDidMount() {
    window.addEventListener('scroll', _.throttle(this.onScroll, 500), false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', _.throttle(this.onScroll, 500), false);
  }

  onScroll() {
    const { currentUser = {}, loadMoreEntries } = this.props;
    const { notifications = {} } = currentUser;
    const { pageInfo = {} } = notifications;
    const { hasNextPage } = pageInfo;
    if (this.state.loading || !hasNextPage) return;
    const footer = document.getElementById('footer');
    const scrollHeight = footer ? footer.offsetHeight + 200 : 500;
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - scrollHeight) {
      this.setState({ loading: true });
      loadMoreEntries().then(
        () => this.setState({ loading: false }),
        error => this.setState({ loading: false, error })
      );
    }
  }

  render() {
    const { currentUser, loading, openTab, viewAllNotifications } = this.props;
    const { notifications, unreadNotificationsCount } = currentUser || {};
    return (
      <div className={styles.notificationsList}>
        <h1>Notifications</h1>
        <div
          onClick={unreadNotificationsCount ? viewAllNotifications : _.noop}
          className={styles.markAllRead}
          data-heap="mark-all-notifications-read"
        >
          Mark All Notifications Read
        </div>
        <div className={styles.listArea} data-heap-segment="web-notifications">
          {(_.isEmpty(notifications) && loading && <LoadingSpinner size="medium" />) ||
            (!notifications && (
              <div className={styles.emptyText}>
                {(openTab === 'all' && 'No notifications.') ||
                  (openTab === 'unread' && 'No unread notifications.') ||
                  (openTab === 'read' && 'No read notifications.')}
              </div>
            ))}
          <TransitionGroup>
            {notifications &&
              notifications.edges.map((notification, idx) => {
                if (openTab === 'unread' && notification.node.viewed) {
                  return null;
                } else if (openTab === 'read' && !notification.node.viewed) {
                  return null;
                } else {
                  return (
                    <CSSTransition key={idx} timeout={0} classNames="fade">
                      <NotificationIndexItemContainer
                        notification={notification.node}
                        currentUserId={currentUser ? currentUser.id : undefined}
                      />
                    </CSSTransition>
                  );
                }
              })}
          </TransitionGroup>
          {this.state.loading && (
            <div>
              <LoadingSpinner size="tiny" type="secondary" />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default NotificationsList;
